export const STORAGE_SECRET = "light-api-box@token";

export const methods = [
  {
    name: "get",
  },
  {
    name: "post",
  },
  {
    name: "put",
  },
  {
    name: "delete",
  },
  {
    name: "options",
  },
  {
    name: "patch",
  },
];

export const monthArrayFriendly = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];
